import axios from 'axios';
import { AlertaDialog } from '../../../CompUtils/Alerta';
import { finalize, init } from '../../../GlobalFeedback/feedbackSlice';
import { CONCURSOAPI } from '../../../../const';
import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { finEtapa } from '../gestionConcursoSlice';
import DictamenForm from './DictamenForm';

const CargaDictamen = ({ concurso }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [alert, setAlert] = useState(false);

  const handleSubmit = (values) => {
    dispatch(init());
    axios
      .put(`${CONCURSOAPI}/llamadoconcurso/dictamen`, {
        idLlamadoConcurso: concurso.idLlamadoConcurso,
        ...values,
      })
      .then((res) => {
        dispatch(finalize());
        setAlert(true);
      });
  };

  const finalizarConfirmacion = () => {
    setAlert(false);
    history.push('/concursos');
    dispatch(finEtapa());
  };
  return (
    <Container>
      <DictamenForm onSubmit={handleSubmit} />
      <br />
      <Button className="float-right" variant="success" type="submit" form="formDictamen">
        Confirmar
      </Button>

      <AlertaDialog size="sm" show={alert} onClose={finalizarConfirmacion} closeText="Cerrar">
        <div className="text-center">
          <i
            className="text-success fa fa-check-circle-o"
            style={{ fontSize: 64, WebkitTextStroke: '5px white' }}></i>
          <p>La información será derivada al coordinador concursal</p>
        </div>
      </AlertaDialog>
    </Container>
  );
};

export default CargaDictamen;
